import React from 'react';
import { Spinner } from 'reactstrap';

/**
 * Componente de carga reutilizable
 */
function Loading({ message = 'Cargando...', size = 'md' }) {
  // Pasar todas las props explícitamente para evitar defaultProps warning
  // El warning viene de reactstrap internamente, pero podemos minimizarlo
  // pasando las props de manera más explícita
  const spinnerProps = {
    color: 'primary',
    type: 'border', // Usar 'border' en lugar de 'grow' para evitar warnings
    ...(size && { size: size }),
  };
  
  return (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
      <div className="text-center">
        <Spinner color="primary" type="border" {...(size && { size })} />
        {message && <p className="mt-3 text-muted">{message}</p>}
      </div>
    </div>
  );
}

export default Loading;

